import { useContext } from 'react'

import { PurchaseAlertContext } from '@provider/Alerts/PurchaseProvider'

import type { IPurchaseAlertContext } from '@base/@types/providers/Alert/PurchaseProvider'

export default function usePurchaseAlert(): IPurchaseAlertContext {
  const context = useContext(PurchaseAlertContext)

  return context
}
